/**
 * This class is used for storing items in a queue.
 */
export default class ProductItemQueue {
    constructor() {
        this.items = {};
        this.timeout = null;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
        this.callbacks = [];
    }
    /**
     * Releases waiting in queue.
     *
     * @param callbacks Callbacks.
     */
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    releaseWaiting(callbacks) {
        for (const callback of callbacks) {
            callback({ items: [], callbacks: [] });
        }
    }
    /**
     * Retrieves items in queue.
     *
     * @param items Array of items.
     * @returns Promise.
     */
    async retrieveItems(items
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    ) {
        this.addItems(items);
        return new Promise((resolve) => {
            if (this.timeout !== null) {
                this.callbacks.push(resolve);
            }
            else {
                this.timeout = window.setTimeout(() => {
                    const items = Object.values(this.items);
                    const callbacks = this.callbacks;
                    this.callbacks = [];
                    this.timeout = null;
                    this.items = {};
                    resolve({ items, callbacks });
                });
            }
        });
    }
    /**
     * Adds items to queue.
     *
     * @param items Array of items.
     */
    addItems(items) {
        for (const item of items) {
            this.items[item.type.toLowerCase() + item.id] = item;
        }
    }
}
//# sourceMappingURL=ProductItemQueue.js.map